export const AnimalSounds = {
    ok: require('./ok.wav'),
    excited: require('./excited.wav'),
    sad: require('./sad.wav'),
    afraid: require('./afraid.wav'),
    angry: require('./angry.wav'),
    happy: require('./happy.wav'),
}
